import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

export const ORIENTATION_MODEL_URL = 'orientation-model';

@Injectable({
  providedIn: 'root'
})
export class OrientationModelService {
  constructor(private http: HttpClient) {}

  getListByPrescriberId(prescriberId: any): any {
    return this.http
      .get(`${environment.apiRoot}${ORIENTATION_MODEL_URL}?prescriberId=${prescriberId}`)
      .toPromise();
  }

  getById(modelId: number) {
    return this.http.get(`${environment.apiRoot}${ORIENTATION_MODEL_URL}/${modelId}`).toPromise();
  }

  create(orientationModel: any) {
    return this.http
      .post(`${environment.apiRoot}${ORIENTATION_MODEL_URL}`, orientationModel)
      .toPromise();
  }

  update(orientationModel: any, modelId: number) {
    return this.http
      .put(`${environment.apiRoot}${ORIENTATION_MODEL_URL}/${modelId}`, orientationModel)
      .toPromise();
  }

  deleteById(modelId: string) {
    return this.http.delete(`${environment.apiRoot}${ORIENTATION_MODEL_URL}/${modelId}`).toPromise();
  }
}
